import { Box, TabPanels, TabPanel, TabPanelProps, Text } from '@chakra-ui/react'

import {
  DetailDrawerHeader,
  DetailDrawerList,
  DetailDrawerListCandidate,
  DetailDrawerSummary,
  DetailDrawerTabs,
} from 'modules/DetailDrawer'

import { SlideOver } from 'components'

import { IResponseBase, ResponseData } from 'api/types'

import { IModel } from 'interfaces/model.interface'
import { ViewData } from 'interfaces/navigationPage.interface'

import { IDA360CandidatesModel } from 'config/apps/IDA360/Custom/IDA360/IDA360Models'
import { ApprovalsData } from 'config/common/baseModel/Approvals'

const StyledTabPanel: React.FC<React.PropsWithChildren<TabPanelProps>> = (
  props
) => <TabPanel height='100%' p={0} {...props} />

type PropTypes<D extends Record<ApprovalsData, any>> = {
  handleClose: () => void
  approval: IResponseBase<Extract<keyof D, string>>
  model: IModel<D>
  title: Extract<keyof D, string>
  viewData: ViewData
}

function Detail<D extends Record<ApprovalsData, any>>(props: PropTypes<D>) {
  const { handleClose, approval, model, title, viewData } = props

  return (
    <SlideOver show={true} handleClose={handleClose}>
      <DetailDrawerHeader
        isLoading={false}
        title={approval && approval[title]}
        handleClose={handleClose}
      />
      <DetailDrawerTabs tabs={['Summary', 'Candidates']}>
        <Box flexGrow={1} flexBasis={0} overflow='hidden'>
          <TabPanels height='100%'>
            <StyledTabPanel p={6} overflow='auto'>
              <DetailDrawerSummary rowData={approval} model={model} />
            </StyledTabPanel>
            <StyledTabPanel>
              {approval.candidateId ? (
                <DetailDrawerList
                  id={1}
                  viewData={viewData}
                  model={IDA360CandidatesModel}
                  ids={[approval.candidateId] as ResponseData}
                  itemComponent={DetailDrawerListCandidate}
                />
              ) : (
                <Text textAlign='center' my={8}>
                  No Candidate data found
                </Text>
              )}
            </StyledTabPanel>
          </TabPanels>
        </Box>
      </DetailDrawerTabs>
    </SlideOver>
  )
}

export default Detail
